/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconImage/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconImage({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconImage",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconImage.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-mo26e': alignSelf,'--mt-2-mo26e': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-mo26e': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-mo26e': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-mo26e': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-mo26e': opacity,'--w-10-mo26e': typeof width === 'number' ? `${width}px` : width,'--h-11-mo26e': typeof height === 'number' ? `${height}px` : height,'--a-7-mo26e': isAnimated ? animation : "none",'--sd-8-mo26e': isAnimated ? strokeDashoffset : 0,'--sd-9-mo26e': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconImage.SvgPath"
  data-view-path={viewPath}
 d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86l-3 3.87L9 13.14 6 17h12l-3.86-5.14z"
 style={{'--f-12-mo26e': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}